import { Dispatch } from 'redux';
import { RootState } from '../reducers/store';
import { AuthReducerActionType, Status } from '../reducers/authReducer';

// Types des actions d'authentification
export const FETCH_STATUS = 'fetch_status';

export const setStatus =
  (status: Status) => async (dispatch: Dispatch<AuthReducerActionType>) => {
    dispatch({ type: FETCH_STATUS, payload: status });
  };

export const login =
  (email: string, password: string, otp?: string) =>
  async (
    dispatch: Dispatch<AuthReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { login },
    } = getState();

    dispatch({ type: FETCH_STATUS, payload: 'authenticating' });
    login(email, password, otp);
  };

export const logout =
  () =>
  async (
    dispatch: Dispatch<AuthReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { logout },
    } = getState();

    dispatch({ type: FETCH_STATUS, payload: 'anonymous' });
    logout();
  };
